import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TFormTypesGroup {
  id: number;
  formTypeCode: string;
  formTypesGroupCategoryCode: string;
}

export interface IFormTypesGroup extends TFormTypesGroup {}

const FormTypesGroup = Model(
  (model: TFormTypesGroup): IFormTypesGroup => {
    const _formTypesGroup: TFormTypesGroup = Object.assign({}, model);

    let create = (formTypesGroup: IFormTypesGroup): IFormTypesGroup => {
      let obj = ValidatableObject(formTypesGroup);
      return obj;
    };

    let formTypesGroup = {
      get id() {
        return _formTypesGroup.id;
      },
      set id(value) {
        _formTypesGroup.id = value;
      },
      get formTypeCode() {
        return _formTypesGroup.formTypeCode;
      },
      set formTypeCode(value) {
        _formTypesGroup.formTypeCode = value;
      },
      get formTypesGroupCategoryCode() {
        return _formTypesGroup.formTypesGroupCategoryCode;
      },
      set formTypesGroupCategoryCode(value) {
        _formTypesGroup.formTypesGroupCategoryCode = value;
      }
    };

    return create(formTypesGroup);
  }
);

export default FormTypesGroup;
